import { request } from './base.service';

export type BackendStatementRow = {
    date: string;   // YYYY-MM-DD
    title: string;
    amount: number; // always positive
    type: 'DEBIT' | 'CREDIT';
    category?: string;
    tag?: string;
    onCredit?: boolean;
};

export const uploadStatement = async (
    userid: string,
    bank: 'rbc' | 'nbc',
    csv: string
): Promise<{ bank: string; name: string; rows: BackendStatementRow[]; count: number }> => {
    return await request('/statements/upload', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ userid, bank, csv }),
    });
};

export const confirmStatement = async (
    userid: string,
    listid: string,
    rows: BackendStatementRow[]
): Promise<{ stored: number; skipped: number; listid: string }> => {
    return await request('/statements/confirm', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({ userid, listid, rows }),
    });
};
